import React from 'react';
import { IconButton } from '@mui/material';
import { colors } from '@roku-web-ui/rds-theme';

import { IconMicrophone, IconMicrophoneMute } from 'components/icons';
import { Tooltip } from 'components/common/Tooltip';
import { useAspenLogger } from 'hooks/useAspenLogger';
import { dispatchEvent } from 'modules/globalEvents';

import { AppLeaf } from 'types/common/leaf';

interface MicrophoneProps {
  leafId: AppLeaf['id'];
  microphoneEnabled: boolean;
  microphonePermissionState: 'granted' | 'prompt' | 'denied' | 'wyze';
}

const microphonePermissionStateMap = {
  granted: 'Speak',
  prompt: 'Speak',
  denied: 'Please enable microphone permissions',
  wyze: 'Microphone is not supported for this camera on web',
};

export const Microphone = ({ leafId, microphoneEnabled, microphonePermissionState }: MicrophoneProps) => {
  const { logAspenEvent } = useAspenLogger();

  return (
    <Tooltip title={microphonePermissionStateMap[microphonePermissionState]} placement="top">
      <span>
        <IconButton
          aria-label="microphone"
          data-testid="button-microphone"
          disabled={['denied', 'wyze'].includes(microphonePermissionState)}
          onClick={() => {
            dispatchEvent({
              leafId,
              event: 'TOGGLE_MICROPHONE',
              data: { newValue: !microphoneEnabled },
            });

            logAspenEvent({
              log_id: 'iot.web.stream.interaction',
              payload: {
                device_id: leafId,
                interaction: 'speak',
              },
            });
          }}
          sx={{
            '&:hover': {
              boxShadow: 'none',
            },
          }}
        >
          {microphoneEnabled ? (
            <IconMicrophone
              sx={{
                color: colors.purple[500],
                opacity: ['denied', 'wyze'].includes(microphonePermissionState) ? 0.5 : 1,
              }}
            />
          ) : (
            <IconMicrophoneMute
              sx={{
                color: colors.grey[400],
                opacity: ['denied', 'wyze'].includes(microphonePermissionState) ? 0.5 : 1,
              }}
            />
          )}
        </IconButton>
      </span>
    </Tooltip>
  );
};
